import { call, put, takeLatest, all } from 'redux-saga/effects';

import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';

import { getForWeb } from './api';
import {
  GET_SETTING_SUCCESS,
  GET_SETTING_REQUESTING,
  GET_SETTING_REQUEST
} from './constants';

export function* get(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: GET_SETTING_REQUESTING });
    const response = yield call(getForWeb);
    yield put({ type: GET_SETTING_SUCCESS, payload: response.data });
  } catch (error) {
    if (error.response?.data.key === 'invalidTenant') {
      action.onError();
    } else {
      yield call(addAPIError, error);
    }
  }
}

export function* watchList() {
  yield takeLatest(GET_SETTING_REQUEST, get);
}

export default function* settingSagas() {
  yield all([watchList()]);
}
